import React from 'react';
import {
  IfFormData,
  InputLabel,
  Right,
  SimpleBlock,
  useFormContextRequired,
} from 'ui-builder';
import { PlanTask } from 'nekst-api';
import { Separator } from 'features/nekst-widgets';
import { RoadmapDescriptionLayoutProps } from './types';
import { CopyRoadmapDescriptionCheckbox } from '../CopyRoadmapDescriptionCheckbox';
import { PortalRoadmapCheckbox } from '../PortalRoadmapCheckbox';
import { RoadmapSmartTagsWysiwyg } from '../../index';
import { PreviewRoadmapButton } from '../../../Projects/Tasks/RoadmapPreview';
import styles from '../RoadmapDescription.module.scss';

type PlanTaskFormData = PlanTask & {
  copyRoadmapDescription?: boolean;
};

export default function RoadmapDescriptionLayoutWeb(
  props: RoadmapDescriptionLayoutProps
) {
  const formContext = useFormContextRequired<PlanTaskFormData>();
  const data = formContext.data;

  const projectId = (data as any)?.projectId;
  const planId = data?.planId;

  return (
    <IfFormData
      conditionFunc={(formData: PlanTaskFormData) =>
        !!formData.isIncludedToRoadmap
      }
    >
      <Separator />
      {props.withCheckbox && <PortalRoadmapCheckbox />}
      <SimpleBlock>
        <Right>
          <CopyRoadmapDescriptionCheckbox />
        </Right>
        <InputLabel
          source="roadmapDescription"
          label="Roadmap Description"
          className={styles.noMargin}
        />
      </SimpleBlock>

      <IfFormData
        conditionFunc={(formData: PlanTaskFormData) =>
          !formData.copyRoadmapDescription
        }
      >
        <RoadmapSmartTagsWysiwyg
          source="roadmapDescription"
          hideLabel
          label="Roadmap Description"
          projectId={projectId}
          planId={planId}
        />
        <PreviewRoadmapButton />
      </IfFormData>
    </IfFormData>
  );
}
